const UTILS = (() => {
  let custom_utils = {
    removeAllChildNodes(parent) {
      while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
      }
    },

    handleize(text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
    },

    resize_image(src, size) {
      var resized = src || '';
      resized = resized.replace('.png', `_${size}.png`);
      resized = resized.replace('.jpg', `_${size}.jpg`);

      return resized;    
    },

    formatMoney(value) {
      return theme.Currency.formatMoney(value).replace('.00', '');
    },

    debounce(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },

    isMobile() {
      return window.matchMedia("(max-width: 749px)").matches;;
    },
    
    getURLParams(url) {
      var params = {};
      var parser = document.createElement('a');
      parser.href = url;
      var query = parser.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
      return params;
    },
    
    addItemsToCart(itemsToAdd, callback) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then((res) => res.json()).then((res) => {
        UTILS.refreshCart();

        if (callback && typeof callback == 'function') {
          callback();
        }
      })
      .catch(console.error);
    },

    removeItemsFromCart(itemsToRemove, callback) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: itemsToRemove })
      })
      .then((res) => res.json()).then((res) => {
        UTILS.refreshCart();

        if (callback && typeof callback == 'function') {
          callback();
        }
      })
      .catch(console.error);
    },
  
    removeItemFromCart(itemToRemove, callback) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(itemToRemove)
      })
      .then((res) => res.json()).then((res) => {
        UTILS.refreshCart();

        if (callback && typeof callback == 'function') {
          callback();
        }
      })
      .catch(console.error);
    },

    updateCartItem(lineItemObj) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(lineItemObj)
      });
    },
  
    getCartJson() {
      return fetch('/cart.js').then(res => res.json());
    },
    
    refreshCart() {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    },

    updateSwiperInstance($swiper) {
      if (!$swiper) return;
      
      $swiper.swiper.update();
    },

    convertStringToHTML(str) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(str, 'text/html');
      return doc.body;
    },

    convertStringToJS(str) {
      var script = document.createElement("script");
      script.text = str;
      document.head.appendChild(script).parentNode.removeChild(script);
    },

    delay(callback, ms) {
      var timer = 0;
      return () => {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => {
          callback.apply(context, args);
        }, ms || 0);
      };
    },

    async PromisesSequential(PromiseArr) {
      let res = [];
      for (let i=0; i < PromiseArr.length; i++) {
        res.push(await PromiseArr[i]);
      }
      return res;  
    }
  };

  return custom_utils;
})();

document.addEventListener('DOMContentLoaded', ()=>{
  function headerDebugger(func){
    var timer;
    return function(event){ if(timer) clearTimeout(timer); timer = setTimeout(func,100,event); };
  }  
  if ( document.querySelectorAll('#shopify-section-announcement').length && document.querySelectorAll('.header-wrapper--overlay').length ){
    let Height$Announcement = document.querySelector('#shopify-section-announcement').clientHeight;
    document.querySelector('.header-wrapper--overlay').style.top = `${Height$Announcement}px`; 
  }
  window.addEventListener("resize",headerDebugger(function(e){
    if ( document.querySelectorAll('#shopify-section-announcement').length && document.querySelectorAll('.header-wrapper--overlay').length ){
      let Height$Announcement = document.querySelector('#shopify-section-announcement').clientHeight;
      document.querySelector('.header-wrapper--overlay').style.top = `${Height$Announcement}px`; 
    }
  }));
});